import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Deserialize, IJsonObject } from 'dcerialize';
import { Observable } from 'rxjs/';
import { map } from 'rxjs/operators';

import { CategoryList } from '../models/category';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  get path(): string {
    return this.apiService.getApiUrl() + 'categories';
  }

  /**
   * GET all course types
   * @returns CategoryList with the results of the request as an observable
   */
  listTypes(): Observable<CategoryList> {
    return this.http
      .get<IJsonObject>(`${this.path}/types`)
      .pipe(map((schoolList) => Deserialize(schoolList, () => CategoryList)));
  }

  listFaculties(): Observable<CategoryList> {
    return this.http
      .get<IJsonObject>(`${this.path}/faculties`)
      .pipe(map((facultyList) => Deserialize(facultyList, () => CategoryList)));
  }
}
